import { Modal } from './Modal';

export function ShortcutsModal({ onClose }) {
  return (
    <Modal onClose={onClose} size="sm">
      <h2 className="modal-title">⌨️ Keyboard Shortcuts</h2>
      <div className="shortcut-list">
        <div className="shortcut-row">
          <span>Show Shortcuts</span>
          <kbd>?</kbd>
        </div>
        <div className="shortcut-row">
          <span>Close Overlays</span>
          <kbd>Esc</kbd>
        </div>
      </div>
      <button type="button" className="btn btn-secondary" onClick={onClose}>
        Close
      </button>
    </Modal>
  );
}
